import effectManager from './module/effect';
import Util from './module/libs/util';
import scrollManager from './module/molecules/scroll';
import Resize from './module/molecules/resize';
import newsManager from './module/molecules/news';
import pagerManager from './module/molecules/pager';
import topManager from './page/top';
import developmentManager from './page/development';
import Developer from './page/developer';
import videoManager from './module/webgl/videoManager';
import newsPage from './page/news';
import smoothScrollManager from './module/scroll/scrollManager';
import youtubeManager from './module/libs/youtube';

let _effect = new effectManager();
const _util = new Util();
let _scroll;
let _resize = new Resize();
let _news = new newsManager();
let _pager = new pagerManager();
let _toppage;
let _development = new developmentManager();
let developer;
let video = new videoManager();
let _newsPage;
let _youtube;

let _sectionMax = ($(".js__section")[0]) ? $(".js__section").length - 1 : 0;
let footerHeight = $('.moreOnDenso.baseComponentStructure').height() + $('.footer.baseComponentStructure').height();

let _cookieArr = [];
let _visited = null;
let _visitCount = null;
let _param = '';
let _paramArray = [];

//全体のデータ管理
let _status = {

    //ページ
    pageID : '',

    //カウント
    nowcurrent : 0, // 現在表示中のcurrent number
    nextcurrent : 0, // 次に表示するcurrent number
    id : 'l-main-copy', // 現在のid
    scrollcount : 0,
    developercarousel : 0,
    iotMovie : 1,
    loading : false,

    //Flg
    Flg : true, // 切替えフラグ（これがtrueの場合はマウスホイールモーションを発火させない）
    changeType : '', // センテンス切替え方法（ページャーかスクロールか）
    scroll : false, // スクロール可能かどうか
    scrollStart : true, // スクロール位置がOかどうか
    scrollEnd : true, // スクロール位置がMAXかどうか
    panelShow : false, // 切替えパネル表示状態（表示中の場合はtrue,非表示mの場合はfalse）
    footerFlg : false, // フッターが表示されてるかどうか
    webglplay : true, // webglが動いてるかどうか
    openingLoaded : false, // オープニング動画が読み込まれたかどうか
    loaded : false, // ページ読み込んだらtrue

    //サイズ
    resizeTime : false,
    w : window.innerWidth,
    h : window.innerHeight,
    dh : $(document).height(),
    wr : 0,

    //scroll
    MOUSE_WHEEL_EVENT : 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll',
    delta : 0,
    scr : 0,
    scrB : 0,
    scrTarget : '',
    scrH : 0,
    scrTimer : 0,
    position:'',

    //webgl
    webglnumber:0,

}

//let _root = '';
let _root = '';

let _path = '';
let _url = location.href;
if ( _url.indexOf('/jp/ja/') != -1){
    _path = '/content/dam/denso/common/language-variation/ja/innovation/technology/maas/';
}else{
    _path = '/content/dam/denso/global/en/innovation/technology/maas/';
}

let scroll = {
    manager : false,
    fpsRate : false
}

/* -----------------------------------------------

 -- event

 -------------------------------------------------- */

let common = function () { //barber reload

    _status.Flg = true;

    if(_status.pageID === 'top'){

        _scroll = new scrollManager();
        _effect.panelInit();

        if($('#js__canvas')[0]){
            $('#vue-switch-scene').find('.p-switch-scene__item').eq(4).click();
            $('#vue-switch-scene').find('.p-switch-scene__item').eq(11).click();
            TweenLite.set($('#js__canvas'), { 'display': 'none' });
        } //とりあえずwebgl開始位置移動して停止

        if(!_visited || _paramArray["mode"] == "preview"){
            video.init(_status,_root,_path);
            if(Useragnt.ios) {
                render();
            }
        }else{
            $('#l-movie-video').css({'display':'none'});
            setTimeout(function () {
                _toppage.movieEnd(_status,_root,_path);
            }, 1e3);
        }
        setTimeout(function () {
            _status.dh = $(document).height();
        }, 300);

    }else if(_status.pageID === 'developer'){
        _status.loaded = true;
        _scroll = new scrollManager();
    }else if(_status.pageID === 'news'){
        _scroll = new scrollManager();
        scroll.manager = new smoothScrollManager(_effect,_status.pageID);
        scroll.manager.init(_status.pageID);
        _youtube = new youtubeManager();
        _youtube.init();
        setTimeout(()=>{
            scroll.manager.resize();
            render();
            _status.loaded = true;
        },6e2);
    }
    if($('.js__split-text')[0]){
        _effect.splitTextInit($('.js__split-text'));
    }

} // common

/* -----------------------------------------------

 -- requestAnimationFrame

 -------------------------------------------------- */

let render = function () {

    if(video.ended && _status.pageID === 'top') return false;

    if(!requestAnimationFrame){
        setTimeout(function () {
            render;
        },1000/60);
    }else{
        requestAnimationFrame(render);
    }
    if(_status.openingLoaded &&  _status.pageID === 'top'){
        video.render(_root,_path);
    }

    scroll.fpsRate = _util.updateTimeRatio();

    if(scroll.manager) scroll.manager.move(scroll.fpsRate);

}

let firstloadRender = function () {

    if(document.getElementById('js__canvas').classList.contains('is-done')){
        common();
        pageManager();
        return false;
    }

    setTimeout(function () {
        firstloadRender();
    },1000/10);

}

/* -----------------------------------------------

 -- pageManager Event

 -------------------------------------------------- */

let pageManager = function () {
    /* 個別ページJS読み込み */
    switch (_status.pageID) {
        case "top":
            _toppage = new topManager();
            if(('sessionStorage' in window) && (window.sessionStorage !== null)) {
                if (sessionStorage.access_count != 'undefined' && sessionStorage.access_count != null && sessionStorage.access_count != 0) {
                    _toppage.init(_status,'',_root,_path);
                    _toppage.movieEnd(_status,_root,_path);
                } else {
                    _toppage.init(_status,'landing',_root,_path);
                }
            }else{
                _toppage.init(_status,'landing',_root,_path);
            }
        break;
        case "developer":
            $('html').addClass('is-no-scroll');
            developer = new Developer();
            developer.init(_status);
            $('.moreOnDenso.baseComponentStructure,.footer.baseComponentStructure').remove();
        break;
        case "news":
            _newsPage = new newsPage(_effect);
            _newsPage.init(_status);
        break;
    }
}

/* -----------------------------------------------

 -- Ready Event

 -------------------------------------------------- */

$(document).on("ready", function () {

    /* browser session */
    if(('sessionStorage' in window) && (window.sessionStorage !== null)) {
        if ($('#top')[0] && sessionStorage.access_count == 'undefined' || $('#top')[0] && sessionStorage.access_count == null || $('#top')[0] && sessionStorage.access_count == 0 ) {
            $('body .pace').css({'display':'block'});
        }
    }

    let _header = $('.headerglobalnavi');
    let _cookie = $('.cookiePolicy');

    if(_header[0]){
        if(_cookie[0]){
            TweenLite.set(_header, {
                y: -(_cookie.outerHeight() + _header.outerHeight() + 50)
            });
        }else{
            TweenLite.set(_header, {
                y: -(_header.outerHeight() + 50)
            });
        }
    }

});

/* -----------------------------------------------

 -- Load Event

 -------------------------------------------------- */

$(window).on('load',function () {

    //paramater
    let _url = location.href;
    if (_url.match(/\?/)) {
        _param = _url.split("?");
        _param = _param[1].split("&");
        let i;
        let vol;

        for (i = 0; i < _param.length; i++) {
            vol = _param[i].split("=");
            _paramArray.push(vol[0]);
            _paramArray[vol[0]] = vol[1];
        }
    }

    if(!$('#l-movie')[0]) return false;

    if(!Useragnt.ios && !_visited || Useragnt.ios && _paramArray["mode"] == "preview") {
        let _openingMovie ='<video id="l-movie-video" class="js__resize-full" muted="muted">' +
            '<source src="' + _root + _path + 'images/opening.mp4" type="video/mp4" /> ' +
            '</video>';
        $('#l-movie').append(_openingMovie);
    }

});

Pace.on("done",function(){

    //cookie
    _cookieArr  = $.cookie();

    _visited = _cookieArr["visited"] && _cookieArr["visited"]!=null ? true : false;
    $.cookie( "visited", "7 days", { expires: 7 });

    if (_cookieArr['visitCount'] == 'NaN' || _cookieArr['visitCount'] == null) {
        _visitCount = 1;
        $.cookie('visitCount', _visitCount);
    } else {
        _visitCount = $.cookie('visitCount');
        _visitCount ++;
        $.cookie('visitCount', _visitCount);
    }
    if( ( _visitCount % 2 ) != 0 ) {
        _status.iotMovie = 2;
    }else{
        _status.iotMovie = 1;
    }

    /* page ID */
    _status.pageID = $('.barba-container').data("namespace");
    if(_status.pageID == 'top' && !_visited){
        firstloadRender();
    }else{
        common();
        pageManager();
    }

    TweenLite.to(window, 0.0001, {scrollTo:{y:0,autoKill:false}});
    TweenLite.set('#c-pager' , { 'opacity': 1 });

    /* denso footer */
    let h = $('.moreOnDenso.baseComponentStructure').height();
    let $footer = $('.moreOnDenso.baseComponentStructure,.footer.baseComponentStructure');
    if(_status.pageID !== 'news') {
        TweenLite.set($('.footer.baseComponentStructure'), {top: h});
        TweenLite.set($footer, {
            opacity: 1,
            // display:'none'
            y: window.innerHeight
        });
    }

    [].forEach.call(document.querySelectorAll('img[data-src]'), function(img) {
        img.setAttribute('src', img.getAttribute('data-src'));
        img.onload = function() {
            img.removeAttribute('data-src');
        };
    });
    [].forEach.call(document.querySelectorAll('[data-bg]'), function(bg) {
        $(bg).css('background-image', 'url('+bg.getAttribute('data-bg')+')');
    });

});

/* -----------------------------------------------

 -- Load and resize Event

 -------------------------------------------------- */

$(window).on('load resize',function () {
    _status.w = window.innerWidth;
    _status.h = window.innerHeight;
    footerHeight = $('.moreOnDenso.baseComponentStructure').height() + $('.footer.baseComponentStructure').height();
    _status.dh = $(document).height();

    if (_status.resizeTime !== false) {
        clearTimeout(_status.resizeTime);
    }
    _status.resizeTime = setTimeout(function() {
        _status.wr = window.innerWidth;
        if ( _status.w != _status.wr ) { // 横幅が変わった時実行する処理
            _status.w = $(window).width();
        }
    }, 200);

    _resize.set();

    if(_status.pageID === 'news') {
        scroll.manager.resize(_status.w,_status.h);
    }

});

/* -----------------------------------------------

 -- click Event

 -------------------------------------------------- */

let Link = '';
let blank = '';
let section;

$('.doc a').on('click', function() {

    Link = $(this).attr("href");
    blank = $(this).attr("target");
    section = $(this).data("section");

    //session
    if(('sessionStorage' in window) && (window.sessionStorage !== null)) {
        sessionStorage.setItem('access_count', section);
        window.sessionStorage.setItem('access_count', section);
        sessionStorage.access_count = section
    }

    if(blank === '_blank'){
        open( Link, "_blank" );
    }else{
        if(_status.pageID==="top") {
            TweenMax.to($("#l-body"), 1.58, {
                opacity: 0,
                scale: 0.99,
                ease: Circ.easeOut,
                onComplete: function () {
                    location.href = Link;
                }
            });
        }else if(_status.pageID==="developer") {
            if(_status.scroll){
                TweenMax.to($(".p-developer-interview").children(),1.58, {
                    opacity:0,
                    scale:0.99,
                    ease: Circ.easeOut,
                    onComplete: function () {
                        location.href = Link;
                    }
                });
            }else{
                TweenLite.set([$(".p-developer-interview__content"),$(".p-developer-interview__image"),$(".p-developer-interview__link")], {display: 'none'});
                TweenMax.to($(".p-developer-interview__main"),1.58, {
                    opacity:0,
                    scale:0.99,
                    ease: Circ.easeOut,
                    onComplete: function () {
                        location.href = Link;
                    }
                });
            }
        }else{
            TweenMax.to(['.baseComponentStructure','#c-pager','#p-news-logo','#l-root'],1.38, {
                opacity:0,
                scale:0.99,
                ease: Circ.easeOut,
                onComplete: function () {
                    location.href = Link;
                }
            });
        }
    }
    return false;
});

/* -----------------------------------------------

 -- news

 -------------------------------------------------- */

let $newsTrigger = $("#l-news__trigger");
let $newsBack = $("#l-news__back,#l-news__bg");

//open
// $newsTrigger.on('click',function () {
//     _news.open(_status);
// });

//close
$newsBack.on('click',function () {
    _news.close(_status);
});

_news.set(_root,_path);

/* -----------------------------------------------

 -- development

 -------------------------------------------------- */

let _developmentList = $('.l-development__point');

_developmentList.on('click', function() {
    let _target = $(this);
    _development.set('click',_target);
});

/* -----------------------------------------------

 -- pager

 -------------------------------------------------- */

let _pagerStatus = {
    $pagerTrigger : $("#c-pager__trigger"),
    $pagerContent : $("#c-pager__content"),
    $pagerList : $("#c-pager li"),
    $pagerLink : $("#c-pager li a"),
    _pagerOpen : false,
    _pagerText : ''
}

//開閉
_pagerStatus.$pagerTrigger.on('click',function () {
    if(_pagerStatus._pagerOpen){
        _pager.close(_status,_pagerStatus);
    }else{
        _pager.open(_status,_pagerStatus);
    }
});

//TOPページでの移動
_pagerStatus.$pagerList.on('click',function () {
    if($(this).data('section') === _status.nextcurrent || _status.pageID!=="top") return false;
    _status.nextcurrent = $(this).data('section');
    pagerMove();
});

let pagerMove = function () {
    _status.Flg = true;
    _status.changeType = 'pager';
    _scroll.normal(_status);
    _pager.close(_status,_pagerStatus);
}

/* -----------------------------------------------

 -- sp derection

 -------------------------------------------------- */

let _angle = 0;

let spDerection = function(){
    _angle = (screen && screen.orientation && screen.orientation.angle) || window.orientation || 0;
    if(_angle % 180 !== 0) {
        $('html').addClass('is-yokomuki');
    } else {
        $('html').removeClass('is-yokomuki');
    }
}

$(window).on('orientationchange', (event) => {
    spDerection();
}).trigger('orientationchange');

/* -----------------------------------------------

 -- scroll

 -------------------------------------------------- */

let _inc;

$(window).on('scroll', function(){

    if(_status.pageID === 'news'){
        _inc = window.pageYOffset || document.documentElement.scrollTop;
        if(scroll.manager) scroll.manager.update(_inc,"");
    }else{
        if(_status.Flg) return false;

        // スクロールしたらフラグをリセット
        _status.scroll = true;
        _status.scrollStart = false;
        _status.scrollEnd = false;
        $("#c-scroll").removeClass("is-show");

        _status.scr = $(this).scrollTop();
        _status.scrB = _status.scr + _status.h;

        if(_status.footerFlg){ //フッター表示中
            _status.scrH = footerHeight;
        }else if(_status.pageID === 'developer'){ //開発者詳細
            _status.scrH = $('.p-developer-interview__scroll').innerHeight() - 1;
        }else{ //通常
            _status.scrTarget = $('.js__section.js__current');
            _status.scrH = _status.scrTarget.children('.l-section__inner').innerHeight() - 1;
        }

        if(_status.scrB >= _status.scrH){
            if(_status.pageID === 'developer' && !Useragnt.mobile){
                _status.position = 'bottom';
                developer.scroll(_status);
            }else{
                _status.scrollEnd = true;
                _status.scroll = false;
                $("#c-scroll").addClass("is-show");
            }
        }else if(_status.scr === 0){
            _status.scrollStart = true;
            _status.scroll = false;
        }else{
            if(_status.pageID === 'developer' && !Useragnt.mobile){
                _status.position = 'no_bottom';
                developer.scroll(_status);
            }
        }
    }

});

/* -----------------------------------------------

 -- scroll Event

 -------------------------------------------------- */

$(document).on(_status.MOUSE_WHEEL_EVENT,function(e){

    if(_status.pageID === 'news') return;

    if(_status.Flg || !_status.loading){ // アニメ中の時などはイベントを殺す
        e.preventDefault();
        return false;
    }

    _status.delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail);

    if (_status.delta < 0) {

        if(_status.pageID === 'developer'){ //developer
            if(_status.scrollEnd){
                e.preventDefault();
                _status.changeType = 'next';
                developer.event(_status);
            }
        }else { //normal
            if (_status.scrollEnd){
                if (_status.footerFlg) return;
                e.preventDefault();
                _scroll.normalScrollNext(_status, _sectionMax);
            }
        }

    } else if(_status.delta > 0) {

        if(_status.pageID === 'developer'){ //developer
            if(_status.scrollStart) {
                _status.changeType = 'prev';
                developer.event(_status);
            }
        }else{ //normal
            if(_status.scrollStart){
                e.preventDefault();
                _scroll.normalScrollPrev(_status);
            }
        }

    }

});

/* [ キーボード操作 ] */
$(document).keyup(function(e){

    if(_status.Flg){ // アニメ中の時などはイベントを殺す
        e.preventDefault();
        return false;
    }

    if(e.keyCode == 40 || e.keyCode == 34 ){

        if(_status.pageID === 'developer'){ //developer
            if(_status.scrollEnd){
                e.preventDefault();
                _status.changeType = 'next';
                developer.event(_status);
            }
        }else { //normal
            if (_status.scrollEnd){
                if (_status.footerFlg) return;
                e.preventDefault();
                _scroll.normalScrollNext(_status, _sectionMax);
            }
        }

    }else if(e.keyCode == 38 || e.keyCode == 33){

        if(_status.scrollStart) e.preventDefault();

        if(_status.pageID === 'developer'){ //developer
            _status.changeType = 'prev';
            developer.event(_status);
        }else { //normal
            if(_status.scrollStart){
                e.preventDefault();
                _scroll.normalScrollPrev(_status);
            }
        }
    }

});

/* [ SMP Tablet用 ]
 ------------------------------------*/

let touchInc = {
    x : 0,
    y : 0,
    pos : 0,
}

document.addEventListener("touchstart",function (e) {
    touchInc.x = e.changedTouches[0].pageX;
    touchInc.y = e.changedTouches[0].pageY;
});
document.addEventListener("touchmove",function (e) {

    if(_status.pageID == 'news') return;
    touchInc.pos = touchInc.y - e.changedTouches[0].pageY;
    if(!_status.loading) e.preventDefault();

    if(_status.pageID !== 'developer' || Useragnt.tablet){
        if(touchInc.pos > 0 && _status.scrollEnd && !_status.footerFlg){
            e.preventDefault();
        }else if(touchInc.pos < 0 && _status.scrollStart){
            e.preventDefault();
        }
    }
}, {passive: false});
document.addEventListener("touchend",function (e) {

    if(_status.pageID == 'news') return;
    if(_status.pageID !== 'developer' || Useragnt.tablet){

        if(_status.Flg) return; // さらにアニメ中の時などはreturnさせる

        let nowX = e.changedTouches[0].pageX;
        let nowY = e.changedTouches[0].pageY;

        if (touchInc.y>nowY&&touchInc.y - nowY >100 && _status.scrollEnd) {

            if(_status.pageID === 'developer'){ //developer
                _status.changeType = 'next';
                developer.event(_status);
            }else{ //normal
                _scroll.normalScrollNext(_status,_sectionMax);
            }

        } else if (touchInc.y<nowY&&nowY-touchInc.y >100 && _status.scrollStart) {

            if(_status.pageID === 'developer'){ //developer
                _status.changeType = 'prev';
                developer.event(_status);
            }else{ //normal
                _scroll.normalScrollPrev(_status);
            }

        }
    }

});

